type AppConfig = {
  apiUrl: string;
};

const normalizeBaseUrl = (value?: string): string | undefined => {
  const v = (value ?? '').trim();
  if (!v) return undefined;
  // remove trailing slashes so callers can safely do `${apiUrl}/api/...`
  return v.replace(/\/+$/, '');
};

const apiUrl =
  normalizeBaseUrl(process.env.REACT_APP_BASE_URL) ??
  // sensible default for local development
  (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8080');

const config: AppConfig = {
  apiUrl
};

export default config;